export default {"src":"/_next/static/media/pomegranate.016ab4b0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};